import { useCallback, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import FileIcon from './icons/fileIcon'
import { MenuButton, MenuButtonControlProps } from './menuButton'
import { useProject } from '../project/hook'
import { useTranslator } from '../translator/hook'
import { SetupSlideModal } from '../modals/help/setupSlideModal'
import { UserContext } from '../user/provider'

export const FileButton = (menuProps: MenuButtonControlProps) => {
  const navigate = useNavigate()
  const { t } = useTranslator()
  const { copyAndOpenProject, createAndOpenProject, saveProject } = useProject()
  const { isOnlineUser } = useContext(UserContext)
  const [showSetupSlide, setShowSetupSlide] = useState(false)
  const menuName = t('file_menu')

  const handleCopy = useCallback(() => {
    copyAndOpenProject()
  }, [copyAndOpenProject])

  const handleNew = useCallback(() => {
    createAndOpenProject()
  }, [createAndOpenProject])

  const handleSave = useCallback(() => {
    saveProject()
  }, [saveProject])

  const handleBack = useCallback(async () => {
    if (await saveProject()) navigate('/list')
  }, [navigate, saveProject])

  const handleHowToSetup = useCallback(() => {
    if (isOnlineUser) {
      setShowSetupSlide(true)
    } else {
      window.open(
        `${import.meta.env.VITE_DIGITANE_LICENSE_URL}/mission/rj1/setup/`,
        '_blank',
        'noopener,noreferrer',
      )
    }
  }, [isOnlineUser])

  return (
    <>
      <SetupSlideModal
        isOpen={showSetupSlide}
        onClose={() => setShowSetupSlide(false)}
      />
      <MenuButton
        menuIcon={<FileIcon className="icon" />}
        menuName={menuName}
        {...menuProps}
      >
        <li className="file-menu-item" onClick={handleNew}>
          {t('file_new')}
        </li>
        <li className="file-menu-item" onClick={handleSave}>
          {t('file_save')}
        </li>
        <li className="file-menu-item" onClick={handleCopy}>
          {t('file_copy_and_save')}
        </li>
        <li className="file-menu-item" onClick={handleBack}>
          {t('file_review')}
        </li>
        <li className="file-menu-item" onClick={() => handleHowToSetup()}>
          {t('menu_how_to_setup')}
        </li>
      </MenuButton>
    </>
  )
}
